import {
  DELETED_CRM_CATEGORY,
  DELETED_CRM_CUSTOMER,
  DELETE_CRM_CUSTOMER_PS,
  DELETE_CRM_CUSTOMER_PS_TASK,
  EDDITED_CRM_CATEGORY,
  EDITED_CRM_CUSTOMER,
  EDITED_CRM_CUSTOMER_PS,
  EDITED_CRM_CUSTOMER_PS_TASK,
  EDITED_CRM_CUSTOMER_TASK,
  GET_CRM,
  GET_CRM_STATS,
  GET_CRM_ATTENTION,
  GET_CRM_BRIEFING,
  GET_CRM_OUTCOME_REPORT,
  GET_CRM_CATEGORIES_BASE,
  GET_CRM_CUSTOMER,
  GET_CRM_CUSTOMER_BASE,
  GET_CRM_CUSTOMER_TRADES,
  NEW_CRM_CATEGORY,
  NEW_CRM_CUSTOMER,
  NEW_CRM_CUSTOMER_BASE,
  NEW_CRM_CUSTOMER_PRODUCT,
  NEW_CRM_CUSTOMER_PRODUCT_TASK,
  NEW_CRM_CUSTOMER_SERVICE,
  NEW_CRM_CUSTOMER_SERVICE_TASK,
} from "./CRMType";

export const CRMReducer = (
  state = {
    ID: "",
    Categories: [],
    LifecycleStages: [],
    LeadSources: [],
    ActivityTypes: [],
    Customers: [],
    Customer: undefined,
    CustomersBase: [],
    CustomerTrades: [],
    CRMStats: null,
    CRMAttention: null,
    CRMBriefing: null,
    CRMOutcomeReport: null,
    CRMRescueSettings: null,
  },
  action
) => {
  switch (action.type) {
    case GET_CRM: {
      return {
        ...state,
        ID: action.Payload._id,
        Categories: action.Payload.Categories || [],
        LifecycleStages: action.Payload.LifecycleStages || [],
        LeadSources: action.Payload.LeadSources || [],
        ActivityTypes: action.Payload.ActivityTypes || [],
        Customers: action.Payload.Customers,
        CRMRescueSettings: action.Payload.RescueSettings ?? null,
      };
    }
    case GET_CRM_STATS: {
      return {
        ...state,
        CRMStats: action.Payload,
      };
    }
    case GET_CRM_ATTENTION: {
      return { ...state, CRMAttention: action.Payload };
    }
    case GET_CRM_BRIEFING: {
      return { ...state, CRMBriefing: action.Payload };
    }
    case GET_CRM_OUTCOME_REPORT: {
      return { ...state, CRMOutcomeReport: action.Payload };
    }
    case NEW_CRM_CUSTOMER: {
      return { ...state, Customers: [...state.Customers, action.Payload] };
    }
    case NEW_CRM_CATEGORY: {
      const listKey = action.Kind === "lifecycle" ? "LifecycleStages" : action.Kind === "source" ? "LeadSources" : action.Kind === "activity" ? "ActivityTypes" : "Categories";
      return { ...state, [listKey]: [...state[listKey], action.Payload] };
    }
    case GET_CRM_CUSTOMER_BASE: {
      return { ...state, CustomersBase: action.Payload };
    }
    case GET_CRM_CATEGORIES_BASE: {
      return { ...state, Categories: action.Payload };
    }
    case NEW_CRM_CUSTOMER_BASE: {
      return {
        ...state,
        CustomersBase: [...state.CustomersBase, action.Payload],
      };
    }
    case GET_CRM_CUSTOMER: {
      return { ...state, Customer: action.Payload };
    }
    case EDITED_CRM_CUSTOMER_TASK: {
      return { ...state, Customer: action.Payload };
    }
    case GET_CRM_CUSTOMER_TRADES: {
      return { ...state, CustomerTrades: action.Payload };
    }
    case EDDITED_CRM_CATEGORY: {
      const editKey = action.Kind === "lifecycle" ? "LifecycleStages" : action.Kind === "source" ? "LeadSources" : action.Kind === "activity" ? "ActivityTypes" : "Categories";
      let data1 = state[editKey];
      const Find1 = data1.find((item) => item._id === action.Payload._id);
      const FindIndexArr1 = data1.indexOf(Find1);
      data1[FindIndexArr1] = action.Payload;
      return { ...state, [editKey]: [...data1] };
    }
    case EDITED_CRM_CUSTOMER: {
      let data3 = state.Customers;
      const Find3 = data3.filter((item) => item._id === action.Payload._id);
      const FindIndexArr3 = data3.indexOf(Find3[0]);
      data3[FindIndexArr3] = action.Payload;
      return { ...state, Customers: [...data3] };
    }
    case DELETED_CRM_CUSTOMER: {
      let data4 = state.Customers;
      const Filter4 = data4.filter((item) => item._id !== action.Payload);
      return { ...state, Customers: [...Filter4] };
    }
    case DELETED_CRM_CATEGORY: {
      const delKey = action.Kind === "lifecycle" ? "LifecycleStages" : action.Kind === "source" ? "LeadSources" : action.Kind === "activity" ? "ActivityTypes" : "Categories";
      const Filter2 = state[delKey].filter((item) => item._id !== action.Payload);
      return { ...state, [delKey]: [...Filter2] };
    }
    case NEW_CRM_CUSTOMER_PRODUCT: {
      let data5 = state.Customers;
      const Filter5 = data5.filter(
        (item) => item._id === action.Payload.CustomerID
      );
      const IndexOf5 = data5.indexOf(Filter5[0]);
      data5[IndexOf5].Products.push(action.Payload.body);
      return { ...state, Customers: [...data5] };
    }
    case NEW_CRM_CUSTOMER_PRODUCT_TASK: {
      let data9 = state.Customer;
      data9.Products.push(action.Payload.body);
      return { ...state, Customer: { ...data9 } };
    }
    case NEW_CRM_CUSTOMER_SERVICE: {
      let data6 = state.Customers;
      const Filter6 = data6.filter(
        (item) => item._id === action.Payload.CustomerID
      );
      const IndexOf6 = data6.indexOf(Filter6[0]);
      data6[IndexOf6].Services.push(action.Payload.body);
      return { ...state, Customers: [...data6] };
    }
    case NEW_CRM_CUSTOMER_SERVICE_TASK: {
      let data10 = state.Customer;
      data10.Services.push(action.Payload.body);
      return { ...state, Customer: { ...data10 } };
    }
    case DELETE_CRM_CUSTOMER_PS: {
      let data7 = state.Customers;
      const FilterCustomer7 = data7.filter(
        (item) => item._id === action.Payload.CustomerID
      );
      const IndexOfFilterCustomer7 = data7.indexOf(FilterCustomer7[0]);
      if (action.Payload.Product === true) {
        const FindProduct7 = data7[IndexOfFilterCustomer7].Products.filter(
          (item) => item._id !== action.Payload.ProductID
        );
        data7[IndexOfFilterCustomer7].Products = FindProduct7;
        return { ...state, Customers: [...data7] };
      } else {
        const FindService7 = data7[IndexOfFilterCustomer7].Services.filter(
          (item) => item._id !== action.Payload.ServiceID
        );
        data7[IndexOfFilterCustomer7].Services = FindService7;
        return { ...state, Customers: [...data7] };
      }
    }
    case DELETE_CRM_CUSTOMER_PS_TASK: {
      let data12 = state.Customer;
      if (action.Payload.Product === true) {
        const FindProduct12 = data12.Products.filter(
          (item) => item._id !== action.Payload.ProductID
        );
        data12.Products = FindProduct12;
        return { ...state, Customer: { ...data12 } };
      } else {
        const FindService12 = data12.Services.filter(
          (item) => item._id !== action.Payload.ServiceID
        );
        data12.Services = FindService12;
        return { ...state, Customer: { ...data12 } };
      }
    }
    case EDITED_CRM_CUSTOMER_PS: {
      let data8 = state.Customers;
      const FilterCustomer8 = data8.filter(
        (item) => item._id === action.Payload.CustomerID
      );
      const IndexOfFilterCustomer8 = data8.indexOf(FilterCustomer8[0]);
      if (action.Payload.Product === true) {
        const FindProduct8 = data8[IndexOfFilterCustomer8].Products.filter(
          (item) => item._id === action.Payload.PSID
        );
        const IndexFindProduct8 = data8[
          IndexOfFilterCustomer8
        ].Products.indexOf(FindProduct8[0]);
        data8[IndexOfFilterCustomer8].Products[IndexFindProduct8] =
          action.Payload.body;
        return { ...state, Customers: [...data8] };
      } else {
        const FindService8 = data8[IndexOfFilterCustomer8].Services.filter(
          (item) => item._id === action.Payload.PSID
        );
        const IndexFindService8 = data8[
          IndexOfFilterCustomer8
        ].Services.indexOf(FindService8[0]);
        data8[IndexOfFilterCustomer8].Services[IndexFindService8] =
          action.Payload.body;
        return { ...state, Customers: [...data8] };
      }
    }
    case EDITED_CRM_CUSTOMER_PS_TASK: {
      let data11 = state.Customer;
      if (action.Payload.Product === true) {
        const FindProduct11 = data11.Products.filter(
          (item) => item._id === action.Payload.PSID
        );
        const IndexFindProduct11 = data11.Products.indexOf(FindProduct11[0]);
        data11.Products[IndexFindProduct11] = action.Payload.body;
        return { ...state, Customer: { ...data11 } };
      } else {
        const FindService11 = data11.Services.filter(
          (item) => item._id === action.Payload.PSID
        );
        const IndexFindService11 = data11.Services.indexOf(FindService11[0]);
        data11.Services[IndexFindService11] = action.Payload.body;
        return { ...state, Customer: { ...data11 } };
      }
    }
    default: {
      return state;
    }
  }
};
